import { TFunction } from 'i18next'

interface AddressBlockerText {
  streetLabel: string
  streetRequired: string
  streetInvalid: string
  streetPlaceholder: string
  apartmentPlaceholder: string
  cityLabel: string
  cityRequired: string
  cityInvalid: string
  cityPlaceholder: string
  stateLabel?: string // missing for gb
  stateRequired: string
  stateInvalid: string
  statePlaceholder: string
  postalLabel: string
  postalRequired: string
  postalInvalid: string
  postalPlaceholder: string
}

export const getCountryText = (t: TFunction, countryCodeTranslationKey: string): AddressBlockerText => {
  switch (countryCodeTranslationKey) {
    case 'ca':
      return {
        streetLabel: t('Street address', { context: 'Input label.' }),
        streetRequired: t('Enter a street address.', { context: 'Input error.' }),
        streetInvalid: t('Provide a valid street address.', { context: 'Input error.' }),
        streetPlaceholder: t('Address line 1', { context: 'Input placeholder.' }),
        apartmentPlaceholder: t('Address line 2 (Optional),', { context: 'Input placeholder.' }),
        cityLabel: t('City', { context: 'Input label.' }),
        cityRequired: t('Enter a city.', { context: 'Input error.' }),
        cityInvalid: t('Provide a valid city name.', { context: 'Input error.' }),
        cityPlaceholder: t('Name', { context: 'Input placeholder.' }),
        stateLabel: t('Province', { context: 'Input label.' }),
        stateRequired: t('Enter a province.', { context: 'Input error.' }),
        stateInvalid: t('Provide a valid province.', { context: 'Input error.' }),
        statePlaceholder: t('Province', { context: 'Input placeholder.' }),
        postalLabel: t('Postal Code', { context: 'Input label.' }),
        postalRequired: t('Enter a postal code.', { context: 'Input error.' }),
        postalInvalid: t('Provide a valid postal code.', { context: 'Input error.' }),
        postalPlaceholder: t('Full postal code', { context: 'Input placeholder.' }),
      }
    case 'gb':
      return {
        streetLabel: t('Street address', { context: 'Input label.' }),
        streetRequired: t('Enter a street address.', { context: 'Input error.' }),
        streetInvalid: t('Provide a valid street address.', { context: 'Input error.' }),
        streetPlaceholder: t('Address line 1', { context: 'Input placeholder.' }),
        apartmentPlaceholder: t('Address line 2 (Optional),', { context: 'Input placeholder.' }),
        cityLabel: t('Town/City', { context: 'Input label.' }),
        cityRequired: t('Enter a city.', { context: 'Input error.' }),
        cityInvalid: t('Provide a valid city name.', { context: 'Input error.' }),
        cityPlaceholder: t('Name', { context: 'Input placeholder.' }),
        stateRequired: t('Enter a state.', { context: 'Input error.' }),
        stateInvalid: t('Provide a valid state.', { context: 'Input error.' }),
        statePlaceholder: t('Ct', { context: 'Input placeholder.' }),
        postalLabel: t('Postcode', { context: 'Input label.' }),
        postalRequired: t('Enter a postcode.', { context: 'Input error.' }),
        postalInvalid: t('Provide a valid postcode.', { context: 'Input error.' }),
        postalPlaceholder: t('Full postcode', { context: 'Input placeholder.' }),
      }
    case 'us':
    default:
      return {
        streetLabel: t('Street address', { context: 'Input label.' }),
        streetRequired: t('Enter a street address.', { context: 'Input error.' }),
        streetInvalid: t('Provide a valid street address.', { context: 'Input error.' }),
        streetPlaceholder: t('Address line 1', { context: 'Input placeholder.' }),
        apartmentPlaceholder: t('Address line 2 (Optional)', { context: 'Input placeholder.' }),
        cityLabel: t('City', { context: 'Input label.' }),
        cityRequired: t('Enter a city.', { context: 'Input error.' }),
        cityInvalid: t('Provide a valid city name.', { context: 'Input error.' }),
        cityPlaceholder: t('Name', { context: 'Input placeholder.' }),
        stateLabel: t('State', { context: 'Input label.' }),
        stateRequired: t('Enter a state.', { context: 'Input error.' }),
        stateInvalid: t('Provide a valid 2-letter state abbreviation (example: NY).', { context: 'Input error.' }),
        statePlaceholder: t('State', { context: 'Input placeholder.' }),
        postalLabel: t('ZIP code', { context: 'Input label.' }),
        postalRequired: t('Enter a ZIP code.', { context: 'Input error.' }),
        postalInvalid: t('Provide a valid ZIP code.', { context: 'Input error.' }),
        postalPlaceholder: t('12345', { context: 'Input placeholder.' }),
      }
  }
}
